import { Component, computed, effect, input, OnInit, output } from '@angular/core';
import { DataTable, IDataClassConfig } from 'app/classes/data-table/data-table';
import { WindowService } from 'app/shared/window.service';

@Component({
  selector: 'app-telemetry-table',
  templateUrl: './telemetry-table.component.html',
  styleUrl: './telemetry-table.component.css',
  standalone: false
})
export class TelemetryTableComponent implements OnInit {
  gatewaysBySite = input.required<IAssetGatewayBySite[]>();
  filter = input<any>();
  filteredAssets: IAssetGatewayBySite[] = [];
  sortBy = [];
  dataTable: DataTable;

  gateways = computed(() => {
    const gateways = [].concat(...this.gatewaysBySite());
    // add a new Date property for each string date
    gateways.forEach(item => item.updatedDate = new Date(item.updatedAt));

    return gateways;
  });

  onAssetSelected = output<IAssetGatewayBySite>();
  isMobile = false;

  constructor(private windowService: WindowService) {
    effect(() => {
      console.log(`The current count is: ${this.gateways().length}`);
      this.filterTable();
    });

    this.isMobile = this.windowService.isMobile();
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    this.clickAsset(ev);
  }

  filterTable() {
    this.filteredAssets = this.gateways();
    let classConfig: IDataClassConfig;

    if (this.isMobile) {
      classConfig = {
        "gatewayTitle": { valueType: "string", title: 'Gateway', align: 'left' },
        "title": { valueType: "string", title: 'Asset', align: 'left' },
        "updatedDate": { valueType: "date", title: 'Updated', align: 'left' },
        "value": { valueType: "number", title: 'Original', align: 'right', isHidden: true },
        "formattedValue": { valueType: "string", title: 'Value', align: 'right', sortUsingKey: 'value' },
      };
    } else {

      classConfig = {
        "gatewayTitle": { valueType: "string", title: 'Gateway', align: 'left' },
        "title": { valueType: "string", title: 'Asset', align: 'left' },
        "assetTypeTitle": { valueType: "string", title: "Sensor", align: 'left' },
        "updatedDate": { valueType: "date", title: 'Updated', align: 'left' },
        "value": { valueType: "number", title: 'Original', align: 'right', isHidden: true },
        "formattedValue": { valueType: "string", title: 'Value', align: 'right', sortUsingKey: 'value' },
      };

    }

    this.dataTable = new DataTable({ data: this.filteredAssets, sortedColumns: null }, classConfig);
  }

  clickAsset(asset: IAssetGatewayBySite) {
    this.onAssetSelected.emit(asset);
  }
}

export interface IAssetGatewayBySite {
  "assetId": number;
  "assetType": number;
  "display"?: string;
  "gatewayId": string;
  "gatewayOnline": string;
  "gatewayTitle": string;
  "identifier": string;
  "max": number;
  "min": number;
  "purposeId": null,
  "rag": null,
  "siteId": number;
  "siteTitle": string;
  "setting": any,
  "title": string;
  "updatedAt": string;
  "updatedDate": Date;
  "value": string;
}
